import React from 'react';
import {
  Switch,
  Route
} from "react-router-dom";
import Login from './view/pages/Login';
import Detail from './view/pages/Detail';
import Page404 from './view/pages/Page404';
import ErrorBoundary from './view/shared/ErrorBoundary';


function App() {
  return (
    <ErrorBoundary >
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/siparis-detay" component={Detail} />
        <Route component={Page404} />
      </Switch>
      
    </ErrorBoundary>

  );
}

export default App;
